import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./inspector.css";
import NoCheckIcon from "../../../../../assets/imgs/amc-domestico/NoGen.svg";
import GenIcon from "../../../../../assets/imgs/amc-domestico/gen.svg";
import axios from "axios";
import { useForm } from "react-hook-form";
import Overlay from "react-bootstrap/Overlay";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FaX } from "react-icons/fa6";
import { IoMdExit } from "react-icons/io";

function WeighingControl() {
  const [shipments, setShipments] = useState([]);
  const [page, setPage] = useState(1);
  const [descriptions, setDescriptions] = useState({});
  const [statusModal, setStatusModal] = useState(false);
  const [alertDays, setAlertDays] = useState(false);
  const [loaderModal, setLoaderModal] = useState(false);
  const [showBtnShowMore, setBtnShowMore] = useState(false);
  const [showLoaderT, setShowLoaderT] = useState(false);
  const [inputDisabled, setInputDisabled] = useState({
    turn: false,
    awb: false,
  });
  const [showOverlay, setShowOverlay] = useState({
    turn: false,
    awb: false,
    start: false,
    end: false,
  });
  const [formValues, setFormValues] = useState({
    start: "",
    end: "",
    turn: "",
    awb: "",
  });

  // Header
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const [openDropdown, setOpenDropdown] = useState(false);

  const navigate = useNavigate();
  const userName = localStorage.getItem("heavy-load-user");

  const logOut = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/user/logout`;
      const body = {
        user_id: localStorage.getItem("heavy-load-email"),
        profile: localStorage.getItem("heavy-load-profile"),
      };
      await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
        },
      });
      localStorage.clear();
      sessionStorage.clear();
      navigate("/amc-domestico/heavy-load/");
    } catch (error) {
      console.log(error);
      Swal.fire("Error", "Error al cerrar sesión", "error");
    }
  };

  const handleOpenDropdown = () => {
    setOpenDropdown(!openDropdown);
  };

  useEffect(() => {
    function getFormattedDate() {
      const days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      const months = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ];

      const now = new Date();
      const dayName = days[now.getDay()];
      const day = now.getDate();
      const monthName = months[now.getMonth()];
      const year = now.getFullYear();

      return `${dayName}, ${day} de ${monthName} ${year}`;
    }

    function getFormattedTime() {
      const now = new Date();
      let hours = now.getHours(); // Mantén las horas tal cual están en formato de 24 horas
      const minutes = now.getMinutes().toString().padStart(2, "0");

      // Devuelve el tiempo en formato 24 horas
      return `${hours}:${minutes}`;
    }

    const interval = setInterval(() => {
      setCurrentDate(getFormattedDate());
      setCurrentTime(getFormattedTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  // Header

  const turnRef = useRef(null);
  const awbRef = useRef(null);
  const startRef = useRef(null);
  const endRef = useRef(null);

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const {
    register: register,
    handleSubmit: handleSubmitForm1,
    watch,
    reset: reset,
    setError,
    formState: { errors: errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      start: getCurrentDate(),
      end: getCurrentDate(),
    },
  });

  const {
    register: registerForm2,
    handleSubmit: handleSubmitForm2,
    reset: resetForm2,
    formState: { errors: errorsForm2 },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      startDate: getCurrentDate(),
      endDate: getCurrentDate(),
    },
  });

  const turn = watch("turn");
  const awb = watch("awb");
  const start = watch("start");
  const end = watch("end");

  const onSubmit = async (data) => {
    if (new Date(data.start) > new Date(data.end)) {
      setError("start", {
        type: "manual",
        message: "La fecha de inicio no puede ser mayor que la de fin",
      });
      return;
    }

    const dateStart = formatDate(data.start);
    const dateEnd = formatDate(data.end);

    try {
      let url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/guard?startDate=${dateStart}&finishDate=${dateEnd}`;

      if (inputDisabled.turn && data.awb) {
        url += `&awb=${data.awb}`;
      }

      if (inputDisabled.awb && data.turn) {
        url += `&turn=${data.turn}`;
      }

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
        },
      });

      if (res.data.code === 1) {
        setShipments(res.data.shipments || []);
      }
    } catch (error) {
      console.error(error);
    }
  };

  function formatDate(dateISO) {
    const [year, month, day] = dateISO.split("-");
    return `${day}/${month}/${year}`;
  }

  const clearFilters = async () => {
    reset({
      start: getCurrentDate(),
      end: getCurrentDate(),
      turn: "",
      awb: "",
    });
    setPage(1);
    setShipments([]);
    setInputDisabled({ turn: false, awb: false });
    await getData();
  };

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    getData(nextPage);
  };

  const getData = async (pageNumber = 1) => {
    try {
      setShowLoaderT(true);
      const res = await axios.get(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/guard?page=${pageNumber}&limit=20`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        if (res.data.current_page === res.data.total_pages) {
          setBtnShowMore(false);
        } else {
          setBtnShowMore(true);
        }

        if (res.data.shipments.length > 0) {
          setShowLoaderT(false);
          setShipments((prevData) => [...prevData, ...res.data.shipments]);
        }
      }
    } catch (error) {
      console.error("error", error);
    }
  };

  const handleChange = (e, id) => {
    setDescriptions((prev) => ({
      ...prev,
      [id]: e.target.value,
    }));
  };

  const handleBlur = async (e, id, originalValue, pallet_number) => {
    const newValue = e.target.value;

    // No hagas nada si no cambió
    if (newValue === originalValue) return;

    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/guard/description_inspection/${id}`,
        {
          description: newValue,
          user_id: localStorage.getItem("heavy-load-email"),
          pallet_number: pallet_number,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );

      if (res.data.code === 1) {
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleTypeShipment = async (e, id, pallet_number, pallet_id) => {
    const type = e.target.value;
    e.target.blur();
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/guard/inspection_type/${id}`,
        {
          type: parseInt(type),
          user_id: `${localStorage.getItem("heavy-load-email")}`,
          pallet_number: pallet_number,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setShipments((prev) =>
          prev.map((item) =>
            item.pallet_id === pallet_id
              ? { ...item, inspection_type: parseInt(type) }
              : item
          )
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getTypeShipments = (type) => {
    switch (type) {
      case 1:
        return "RX";
      case 2:
        return "ETD";
      case 3:
        return "Manual";
      default:
        return "";
    }
  };

  const finishInspection = async (id, value, pallet_number, pallet_id) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text:
          value === 1
            ? "¿Deseas finalizar la inspección?"
            : "¿Deseas cancelar la inspección?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, continuar",
        cancelButtonText: "Cancelar",
      });

      if (!result.isConfirmed) return;

      const res = await axios.put(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/guard/status_inspection/${id}`,
        {
          status: parseInt(value),
          user_id: `${localStorage.getItem("heavy-load-email")}`,
          pallet_number: pallet_number,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setShipments((prev) =>
          prev.map((item) =>
            item.pallet_id === pallet_id
              ? { ...item, inspection_status: parseInt(value), status: 7 }
              : item
          )
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getInpectionTextShipments = (type) => {
    switch (type) {
      case 0:
        return "Incorrecto";
      case 1:
        return "Correcto";
      default:
        return "";
    }
  };

  const handleMachine = async (e, id, pallet_number, pallet_id) => {
    const type = e.target.value;
    e.target.blur();
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/guard/number_machine/${id}`,
        {
          machine_id: type,
          user_id: `${localStorage.getItem("heavy-load-email")}`,
          pallet_number: pallet_number,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setShipments((prev) =>
          prev.map((item) =>
            item.pallet_id === pallet_id ? { ...item, machine_id: type } : item
          )
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (turn && turn.trim() !== "") {
      setInputDisabled((prev) => ({ ...prev, awb: true }));
    } else {
      setInputDisabled((prev) => ({ ...prev, awb: false }));
    }

    if (awb && awb.trim() !== "") {
      setInputDisabled((prev) => ({ ...prev, turn: true }));
    } else {
      setInputDisabled((prev) => ({ ...prev, turn: false }));
    }
  }, [turn, awb]);

  const handleModalClick = (event) => {
    event.stopPropagation();
  };

  const formatDateWS = (dateString) => {
    setLoaderModal(true);
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const setInpectionType = (type) => {
    switch (type) {
      case 1:
        return "RX";
      case 2:
        return "ETD";
      case 3:
        return "Manual";
      default:
        return "-";
    }
  };

  const handleExportForm = async (data) => {
    const { startDate, endDate } = data;

    const start = new Date(startDate);
    const end = new Date(endDate);

    const diffInMs = end - start;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    try {
      if (diffInDays > 7) {
        setAlertDays(true);
        return;
      }
      setAlertDays(false);
      const formattedStart = formatDateWS(startDate);
      const formattedEnd = formatDateWS(endDate);

      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/guard?startDate=${formattedStart}&finishDate=${formattedEnd}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
        },
      });

      const transformShipments = response.data.shipments.map((item) => ({
        "# de turno": item.turn_number,
        "# de embarque": item.tag_number,
        "# Tarima": item.number_pallet,
        Cliente: item.customer_name,
        "Hora emisión": item.created_at,
        "# Guia": item.awb ? item.awb : "-",
        Descripción: item.merchandise_description,
        Observaciones: item.inspection_description
          ? item.inspection_description
          : "-",
        Destino: item.destination,
        Piezas: item.pieces,
        "Tipo de inspección": setInpectionType(item.inspection_type),
        "Máquina inspección": item.machine_id,
        Inspección: getInpectionTextShipments(item.inspection_status),
      }));

      await generateExcelExport(
        transformShipments,
        formattedStart,
        formattedEnd
      );
      setLoaderModal(false);
      setStatusModal(false);
      resetForm2();
      setAlertDays(false);
    } catch (error) {
      setLoaderModal(false);
      setStatusModal(false);
      resetForm2();
      setAlertDays(false);
      Swal.fire({
        title: "Error",
        text: "Error al exportar, intentelo de nuevo más tarde",
        icon: "error",
      });
    }
  };

  const generateExcelExport = async (data, startDate, endDate) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Inspector");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(blob, `inspector-${startDate}-${endDate}.xlsx`);
  };

  const renderExportModal = () => {
    return (
      <div className="inspector-modal" onClick={handleModalClick}>
        <div className="kpi-header-modal">
          <h4>Exportar</h4>
          <FaX
            style={{ color: "#dc0f38", cursor: "pointer" }}
            onClick={() => {
              setStatusModal(false);
              resetForm2();
              setAlertDays(false);
            }}
          />
        </div>

        {!loaderModal ? (
          <div className="inspector-body-modal">
            <form
              id="exportExcel"
              className="formRenderExport"
              onSubmit={handleSubmitForm2(handleExportForm)}
            >
              <div className="exportFormContent">
                <label>Fecha Inicio</label>
                <input
                  type="date"
                  {...registerForm2("startDate", {
                    required: "Este campo es obligatorio",
                    onChange: () => setAlertDays(false),
                  })}
                />
                {errorsForm2.startDate && (
                  <p className="errorExport">{errorsForm2.startDate.message}</p>
                )}
              </div>

              <div className="exportFormContent">
                <label>Fecha Final</label>
                <input
                  type="date"
                  {...registerForm2("endDate", {
                    required: "Este campo es obligatorio",
                    onChange: () => setAlertDays(false),
                  })}
                />
                {errorsForm2.endDate && (
                  <p className="errorExport">{errorsForm2.endDate.message}</p>
                )}
              </div>

              <button type="submit" form="exportExcel">
                Exportar
              </button>
            </form>

            {alertDays && (
              <div className="alertdays">
                <p>El rango de fecha tiene que ser menor a 7 días</p>
              </div>
            )}
          </div>
        ) : (
          <div className="modal-container">
            <span class="loader-inspector"></span>
          </div>
        )}
      </div>
    );
  };
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const subscription = watch((value) => {
      setFormValues({
        start: value.start || "",
        end: value.end || "",
        turn: value.turn || "",
        awb: value.awb || "",
      });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  return (
    <>
      <div className="weighing-container">
        <div className="header-inspector">
          <div className="header-hours">
            <div className="hours">
              <span>{currentDate}</span>
              <span>{currentTime}</span>
            </div>
            <div className="user">
              <div className="username">
                <span>Usuario: {userName}</span>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={handleOpenDropdown}
                >
                  ▼
                </span>
              </div>
              {openDropdown && (
                <div className="dropdownMenuHeaderInspec">
                  <ul>
                    <li>
                      <button
                        type="button"
                        className="exit-btn"
                        onClick={logOut}
                      >
                        Cerrar sesión <IoMdExit />
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="body-weighing">
          <div className="table-container">
            <div className="actions-container">
              <form onSubmit={handleSubmitForm1(onSubmit)}>
                <div className="inputs-con">
                  <div className="input-ind">
                    <div class="form-floating mb-3">
                      <input
                        type="text"
                        class={`form-control ${
                          errors.turn ? "is-invalid" : ""
                        }`}
                        id="turn"
                        name="turn"
                        placeholder="Turno"
                        {...register("turn", {
                          pattern: {
                            value: /^[0-9]+$/,
                            message: "Solo se permiten números",
                          },
                        })}
                        ref={(e) => {
                          register("turn").ref(e);
                          turnRef.current = e;
                        }}
                        onFocus={() =>
                          setShowOverlay((prev) => ({ ...prev, turn: true }))
                        }
                        onBlur={() =>
                          setShowOverlay((prev) => ({ ...prev, turn: false }))
                        }
                      />
                      <label for="turn">Turno</label>
                      <Overlay
                        target={turnRef.current}
                        show={!!errors.turn && showOverlay.turn}
                        placement="top"
                      >
                        {(props) => (
                          <div
                            {...props}
                            style={{
                              backgroundColor: "rgba(255, 0, 0, 0.85)",
                              padding: "5px 10px",
                              color: "white",
                              borderRadius: 4,
                              fontSize: 12,
                              zIndex: 9999,
                              marginBottom: "10px",
                              ...props.style,
                            }}
                          >
                            {errors.turn?.message}
                          </div>
                        )}
                      </Overlay>
                    </div>
                  </div>
                  <div className="input-ind">
                    <div class="form-floating mb-3">
                      <input
                        type="text"
                        class={`form-control ${errors.awb ? "is-invalid" : ""}`}
                        id="awb"
                        name="awb"
                        placeholder="Guía"
                        {...register("awb", {
                          pattern: {
                            value: /^\d{3}-\d{8}$/,
                            message: "Formato No. Guía invalido",
                          },
                        })}
                        ref={(e) => {
                          register("awb").ref(e);
                          awbRef.current = e;
                        }}
                        onFocus={() =>
                          setShowOverlay((prev) => ({ ...prev, awb: true }))
                        }
                        onBlur={() =>
                          setShowOverlay((prev) => ({ ...prev, awb: false }))
                        }
                      />
                      <label for="awb">Guía</label>
                      <Overlay
                        target={awbRef.current}
                        show={!!errors.awb && showOverlay.awb}
                        placement="top"
                      >
                        {(props) => (
                          <div
                            {...props}
                            style={{
                              backgroundColor: "rgba(255, 0, 0, 0.85)",
                              padding: "5px 10px",
                              color: "white",
                              borderRadius: 4,
                              fontSize: 12,
                              zIndex: 9999,
                              marginBottom: "10px",
                              ...props.style,
                            }}
                          >
                            {errors.awb?.message}
                          </div>
                        )}
                      </Overlay>
                    </div>
                  </div>
                  <div className="input-ind">
                    <div class="form-floating mb-3">
                      <input
                        type="date"
                        class={`form-control ${
                          errors.start ? "is-invalid" : ""
                        }`}
                        id="start"
                        name="start"
                        placeholder="Fecha inicio"
                        {...register("start", {
                          required: "Selecciona una fecha de inicio",
                          validate: (value) => {
                            if (
                              start &&
                              end &&
                              new Date(value) > new Date(end)
                            ) {
                              return "La fecha de inicio no puede ser mayor que la de fin";
                            }
                            return true;
                          },
                        })}
                        ref={(e) => {
                          register("start").ref(e);
                          startRef.current = e;
                        }}
                        onFocus={() =>
                          setShowOverlay((prev) => ({ ...prev, start: true }))
                        }
                        onBlur={() =>
                          setShowOverlay((prev) => ({ ...prev, start: false }))
                        }
                      />
                      <label for="start">Fecha inicio</label>
                      <Overlay
                        target={startRef.current}
                        show={!!errors.start && showOverlay.start}
                        placement="top"
                      >
                        {(props) => (
                          <div
                            {...props}
                            style={{
                              backgroundColor: "rgba(255, 0, 0, 0.85)",
                              padding: "5px 10px",
                              color: "white",
                              borderRadius: 4,
                              fontSize: 12,
                              zIndex: 9999,
                              marginBottom: "10px",
                              ...props.style,
                            }}
                          >
                            {errors.start?.message}
                          </div>
                        )}
                      </Overlay>
                    </div>
                  </div>
                  <div className="input-ind">
                    <div class="form-floating mb-3">
                      <input
                        type="date"
                        class={`form-control ${errors.end ? "is-invalid" : ""}`}
                        id="end"
                        name="end"
                        placeholder="Fecha fin"
                        {...register("end", {
                          required: "Selecciona una fecha de fin",
                        })}
                        ref={(e) => {
                          register("end").ref(e);
                          endRef.current = e;
                        }}
                        onFocus={() =>
                          setShowOverlay((prev) => ({ ...prev, end: true }))
                        }
                        onBlur={() =>
                          setShowOverlay((prev) => ({ ...prev, end: false }))
                        }
                      />
                      <label for="floatingInput">Fecha fin</label>
                      <Overlay
                        target={endRef.current}
                        show={!!errors.end && showOverlay.end}
                        placement="top"
                      >
                        {(props) => (
                          <div
                            {...props}
                            style={{
                              backgroundColor: "rgba(255, 0, 0, 0.85)",
                              padding: "5px 10px",
                              color: "white",
                              borderRadius: 4,
                              fontSize: 12,
                              zIndex: 9999,
                              marginBottom: "10px",
                              ...props.style,
                            }}
                          >
                            {errors.end?.message}
                          </div>
                        )}
                      </Overlay>
                    </div>
                  </div>
                </div>
                <div className="buttons-con">
                  <button
                    type="submit"
                    className="btn_filter"
                    id="btn_filter"
                    disabled={
                      !formValues.start ||
                      !formValues.end ||
                      (!formValues.turn && !formValues.awb)
                    }
                  >
                    Filtrar
                  </button>
                  <button
                    type="button"
                    className="dlt_filter"
                    id="dlt_filter"
                    onClick={clearFilters}
                  >
                    Borrar filtros
                  </button>
                  <button
                    type="button"
                    className="export_btn"
                    onClick={() => setStatusModal(true)}
                  >
                    Exportar
                  </button>
                </div>
              </form>
            </div>

            <div className="content-table-inspect">
              <table className="sticky-table-hl-inspector">
                <thead>
                  <tr>
                    <th># Turno</th>
                    <th># Embarque</th>
                    <th># Tarima</th>
                    <th>Cliente</th>
                    <th>Hora emisión</th>
                    <th># Guía</th>
                    <th>Descripción</th>
                    <th>Observaciones</th>
                    <th>Destino</th>
                    <th>Piezas</th>
                    <th>Tipo de inspección</th>
                    <th>Maquina inspección</th>
                    <th>Inspección</th>
                  </tr>
                </thead>
                <tbody>
                  {shipments.map((row, index) => (
                    <tr
                      key={index}
                      style={{
                        background:
                          index % 2 === 0 ? "FFFFFF" : "rgba(213, 212, 212, 1)",
                      }}
                    >
                      <td style={{background: (row.top_user && row.top_user === 1) ? "#ff0073" : ""}} >{row.turn_number ? row.turn_number : "-"}</td>
                      <td>{row.tag_number ? row.tag_number : "-"}</td>
                      <td>{row.number_pallet ? row.number_pallet : "-"}</td>
                      <td>{row.customer_name ? row.customer_name : "-"}</td>
                      <td>{row.created_at ? row.created_at : "-"}</td>
                      <td>{row.awb ? row.awb : "-"}</td>
                      <td>
                        {row.merchandise_description
                          ? row.merchandise_description
                          : "-"}
                      </td>
                      <td style={{ padding: 0 }}>
                        <textarea
                          className="observations"
                          value={
                            descriptions[row.pallet_id] ??
                            row.inspection_description ??
                            ""
                          }
                          onChange={(e) => handleChange(e, row.pallet_id)}
                          onBlur={(e) =>
                            handleBlur(
                              e,
                              row.id,
                              row.inspection_description,
                              row.number_pallet
                            )
                          }
                          disabled={
                            "inspection_status" in row ||
                            (row.status === 5 && !("inspection_status" in row))
                          }
                          readOnly={
                            "inspection_status" in row ||
                            (row.status === 5 && !("inspection_status" in row))
                          }
                        />
                      </td>
                      <td>{row.destination ? row.destination : "-"}</td>
                      <td>{row.pieces ? row.pieces : "-"}</td>
                      <td style={{ padding: 0 }}>
                        {row.status === 5 && !("inspection_status" in row) ? (
                          "-"
                        ) : "inspection_status" in row ? (
                          getTypeShipments(row.inspection_type)
                        ) : (
                          <select
                            className="inspection"
                            name="inspection"
                            id="inspection"
                            value={row.inspection_type ?? 1}
                            onChange={(e) =>
                              handleTypeShipment(
                                e,
                                row.id,
                                row.number_pallet,
                                row.pallet_id
                              )
                            }
                          >
                            <option value={1}>RX</option>
                            <option value={2}>ETD</option>
                            <option value={3}>Manual</option>
                          </select>
                        )}
                      </td>
                      <td style={{ padding: 0 }}>
                        {row.status === 5 && !("inspection_status" in row) ? (
                          "-"
                        ) : "inspection_status" in row ? (
                          row.machine_id
                        ) : row.inspection_type !== 1 ? (
                          "-"
                        ) : (
                          <select
                            className="rx_machine"
                            name="rx_machine"
                            id="rx_machine"
                            value={row.machine_id ?? ""}
                            onChange={(e) =>
                              handleMachine(
                                e,
                                row.id,
                                row.number_pallet,
                                row.pallet_id
                              )
                            }
                          >
                            <option value="">Selecciona..</option>
                            <option value={"A"}>A</option>
                            <option value={"B"}>B</option>
                            <option value={"C"}>C</option>
                            <option value={"D"}>D</option>
                            <option value={"E"}>E</option>
                          </select>
                        )}
                      </td>
                      <td>
                        {row.status === 5 && !("inspection_status" in row) ? (
                          "Cancelado"
                        ) : "inspection_status" in row ? (
                          getInpectionTextShipments(row.inspection_status)
                        ) : (
                          <div className="actions">
                            <button
                              className="check-btn"
                              disabled={
                                row.inspection_type === 1 && !row.machine_id
                              }
                              style={
                                row.inspection_type === 1 && !row.machine_id
                                  ? { cursor: "not-allowed" }
                                  : { cursor: "pointer" }
                              }
                              onClick={() =>
                                finishInspection(
                                  row.id,
                                  1,
                                  row.number_pallet,
                                  row.pallet_id
                                )
                              }
                            >
                              <img
                                src={GenIcon}
                                alt="check"
                                style={{ width: "20px", height: "20px" }}
                              />
                            </button>
                            <button
                              className="no-check-btn"
                              disabled={
                                row.inspection_type === 1 && !row.machine_id
                              }
                              style={
                                row.inspection_type === 1 && !row.machine_id
                                  ? { cursor: "not-allowed" }
                                  : { cursor: "pointer" }
                              }
                              onClick={() =>
                                finishInspection(
                                  row.id,
                                  0,
                                  row.number_pallet,
                                  row.pallet_id
                                )
                              }
                            >
                              <img
                                src={NoCheckIcon}
                                alt="no Check"
                                style={{ width: "20px", height: "20px" }}
                              />
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
                {showBtnShowMore && !showLoaderT && (
                  <button className="btn-load" onClick={handleLoadMore}>
                    Mostrar más
                  </button>
                )}
                {showLoaderT && (
                  <div className="load-t-c">
                    <div className="loader-table"></div>
                  </div>
                )}
              </table>
            </div>
          </div>
        </div>

        <div
          className={`kpi-modal-bg ${statusModal ? "active" : ""}`}
          onClick={() => {
            setStatusModal(false);
            resetForm2({
              startDate: getCurrentDate(),
              endDate: getCurrentDate(),
            });
            setAlertDays(false);
          }}
        >
          {statusModal && renderExportModal()}
        </div>
      </div>
    </>
  );
}

export default WeighingControl;
